module.exports = __webpack_public_path__ + "8fa18a0ec32dd5a9817a2da3ed8cdda5.webp";


//////////////////
// WEBPACK FOOTER
// ./apps/www.dawnofwar.com/src/static/img/war_has_a_price-1050.webp
// module id = 615
// module chunks = 0